import { makeAutoObservable } from "mobx";
import type { GstFormValues } from "helpers/forms/acn/abnTypes";
import type { CompanyClient } from "services/company/companyClient";
import { CompanyAcnGSTUpdateData } from "services/company/companyTypes";
import type { CompanyStore } from "./companyStore";

interface GstCompanyState {
  gstData?: GstFormValues;
}
export class GstCompanyStore {
  private _state: GstCompanyState = {};

  constructor(
    private readonly _companyStore: CompanyStore,
    private readonly _companyClient: CompanyClient,
  ) {
    makeAutoObservable(this);
  }

  get state(): GstCompanyState {
    return this._state;
  }

  set state(value: GstCompanyState) {
    this._state = value;
  }

  get gstData(): GstFormValues | undefined {
    return this.state.gstData;
  }

  private set gstData(gstData: GstFormValues | undefined) {
    this.state.gstData = gstData;
  }

  async updateGST(data: GstFormValues): Promise<void> {
    // Store the GST data in local state
    this.gstData = data;

    // Update the company with GST data using CompanyAcnGSTUpdateData
    // Note: By the time data reaches here, enum keys have been transformed to enum values by step stores
    await this._companyClient.updateCompany(
      this._companyStore.getCompany().id,
      new CompanyAcnGSTUpdateData({
        gstRegistrationRequested: data.gstRegistrationRequested ?? false,
        gstStartDate: data.gstStartDate,
        gstIsVoluntary: undefined,
        gstTurnover: data.gstTurnover as any,
        gstUseCashAccounting: data.gstUseCashAccounting,
        gstImportsGoods: data.gstImportsGoods,
        gstLodgementFrequency: data.gstLodgementFrequency as any,
        gstAccountName: undefined,
        gstBsb: undefined,
        gstAccountNumber: undefined,
        gstAccountHolderTypeCode: undefined,
      }),
    );

    // Reload company data to get updated state
    await this._companyStore.init();
  }
}
